"use client";

import React from "react";
import { Clock, Shield, Tag } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  id: "price",
  title: "Reduced Risk",
  description: "Engineering-led frameworks that identify and mitigate structural volatility before it impacts your bottom line through rigorous stress testing."
}, {
  id: "insurance",
  title: "Certainty in Complexity",
  description: "Transforming ambiguous data into actionable roadmaps with precision-grade forecasting and strategic oversight for every project phase."
}, {
  id: "time",
  title: "Engineered Momentum",
  description: "Systematic acceleration of project lifecycles through optimized resource allocation and lean operational protocols that ensure timely delivery."
}];
export default function WhyWartmannUmzuege() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222589" id="key-benefits" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-5"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tighter mb-6">
            Why Momentum
          </h2>
          <p className="font-sans text-lg md:text-xl text-muted-foreground leading-relaxed">
            Our engineered approach provides the structural integrity required for high-stakes decision making, ensuring clarity and precision in every outcome.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, i) => {
          const Icon = feature.id === "price" ? Shield : feature.id === "insurance" ? Tag : Clock;
          return <div key={feature.id} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 100}`} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(32px)",
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="h-full border-border bg-card shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 group">
                  <CardHeader className="pb-4">
                    <div className="w-14 h-14 rounded-xl bg-accent/20 flex items-center justify-center mb-4 group-hover:bg-accent/30 transition-colors duration-300">
                      <Icon className="w-7 h-7 text-accent-foreground" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl text-foreground tracking-tight">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="font-sans text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}